import FileService from '../../../../services/file-service';
import FormatService from '../../../../services/format-service';
import FormService from '../../../../services/form-service';
import { FILE_EXTENSION_LIST_IMAGE } from '../../../../constants/system/file-extensions';
import ACCOUNT_USER_TYPE_GROUP_EXTERNAL from '../../../../constants/entity/account-user-type-groups';

const SettingsUserInternalValidator: Validator = (values: FormValues): ValidationErrors => {
  const isAccessLevelView: boolean = values.accountUserTypeGroup
    && values.accountUserTypeGroup === ACCOUNT_USER_TYPE_GROUP_EXTERNAL;

  const errors: ValidationErrors = {};

  const userRequiredFields: string[] = [
    'firstName',
    'lastName',
    'email',
    'role',
  ];

  userRequiredFields.forEach((field: string): void => {
    if (!values[field] || !values[field].toString().trim()) {
      errors[field] = 'Required';
    }
  });

  if (isAccessLevelView && values.accountUserDeals && values.accountUserDeals.length) {
    if (!errors.accountUserDealAccessLevels) {
      errors.accountUserDealAccessLevels = {};
    }

    values.accountUserDeals.forEach((accountUserDeal: ValidationEntityInput): void => {
      const formKeyAccountUserDeal: string = FormService.getIndexedFormFieldKey(accountUserDeal.id);

      if (!values.accountUserDealAccessLevels || !values.accountUserDealAccessLevels[formKeyAccountUserDeal]) {
        errors.accountUserDealAccessLevels[formKeyAccountUserDeal] = 'Required';
      }
    });

    if (errors.accountUserDealAccessLevels && !Object.keys(errors.accountUserDealAccessLevels).length) {
      delete errors.accountUserDealAccessLevels;
    }
  }

  if (!values.address && values.streetAddress) {
    errors.streetAddress = 'Incorrect address value';
  }

  if (values.password && !values.passwordConfirm) {
    errors.passwordConfirm = 'Required';
  }

  if (values.email && !FormatService.isValidEmail(values.email)) {
    errors.email = 'Invalid email address';
  }

  if (values.phone && !FormatService.isValidPhoneNumber(values.phone)) {
    errors.phone = 'Invalid phone number';
  }

  if (values.phoneWork && !FormatService.isValidPhoneNumber(values.phoneWork)) {
    errors.phoneWork = 'Invalid phone number';
  }

  if (values.passwordConfirm && !values.password) {
    errors.password = 'Required';
  }

  if (values.password && !FormatService.isValidPassword(values.password)) {
    errors.password = `Password must contain ${FormService.PASSWORD_FIELD_LENGTH_MIN} characters, at least one `
      + 'letter in lower case, one letter in upper case and one number or one symbol';
  }

  if (values.password && values.passwordConfirm && values.password !== values.passwordConfirm) {
    errors.passwordConfirm = 'Password confirmation does not match';
  }

  if (values.photo && !FileService.checkFileExtension(values.photo, FILE_EXTENSION_LIST_IMAGE)) {
    errors.photo = 'Incorrect file type';
  }

  return errors;
};

export default SettingsUserInternalValidator;
